import React, { Component } from "react";
import { connect } from "react-redux";
import { Navbar, Nav, NavItem } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { Translate } from "react-i18nify";
import createReactClass from "create-react-class";

import { baseAppRouter } from "../../utils/config";
import loginApi from "../../api/loginApi";
import UploadProgress from "../views/utils/UploadProgress";
import NotificationHeader from "../views/utils/NotificationHeader";

import "./Header.css";

class Header extends Component {
	constructor(props) {
		super(props);
		this.handleLink = this.handleLink.bind(this);
		this.renderNavBar = this.renderNavBar.bind(this);
		this.logout = this.logout.bind(this);
	}
	handleLink(e, destination) {
		if (
			window.location.href.indexOf(destination) > 0 &&
			window.location.href.indexOf(destination) + destination.length ===
				window.location.href.length
		)
			e.preventDefault();
	}
	componentDidMount() {
		if (this.props.config.css.header && this.props.config.css.header.activeColor) {
			let style = document.createElement("style");
			style.appendChild(document.createTextNode(""));
			document.head.appendChild(style);

			// adding css from javascript for LinkContainer
			style.sheet.insertRule(
				"ul.navbar-nav li.active {background-color:" +
					this.props.config.css.header.activeColor +
					"}",
				0
			);
		}
	}
	logout() {
		loginApi.logout(this.props.userToken);
	}

	// NavBar based on logged or not
	renderNavBar() {
		let navBar = null;

		if (process.env.NODE_ENV === "development" || this.props.logged) {
			const uploadNavbarStyle = { width: 200, marginTop: 5, marginBottom: 0 };
			const NavDivider = createReactClass({
				render: function () {
					return <li style={uploadNavbarStyle}>{this.props.children}</li>;
				},
			});
			const pStyle = { marginBottom: 0 };
			navBar = (
				<div>
					<Nav className="float-left">
						<LinkContainer
							className="float-left"
							onClick={(e) => this.handleLink(e, baseAppRouter + "runningTasks")}
							to={baseAppRouter + "runningTasks"}
							activeClassName="active"
						>
							<NavItem>
								<p style={pStyle}>
									<Translate value="header.commandList" />
									<NotificationHeader />
								</p>
							</NavItem>
						</LinkContainer>
						{/* {!this.props.uploadEnabled || (
              <LinkContainer
                onClick={e => this.handleLink(e, baseAppRouter + "upload")}
                to={baseAppRouter + "upload"}
                activeClassName="active"
              >
                <NavItem>
                  <p style={pStyle}>
                    <Translate value="header.uploadDocument" />
                  </p>
                </NavItem>
              </LinkContainer>
            )} */}
						<NavDivider>
							<UploadProgress />
						</NavDivider>
					</Nav>
					<Nav className="float-right" pullRight>
						{!this.props.userSuperAdmin || (
							<LinkContainer
								onClick={(e) =>
									this.handleLink(e, baseAppRouter + "configPretraitement")
								}
								to={baseAppRouter + "configPretraitement"}
								activeClassName="active"
							>
								<NavItem>
									<p style={pStyle}>Administration pré-traitement</p>
								</NavItem>
							</LinkContainer>
						)}
						<NavItem onClick={this.logout}>
							<Translate value="header.logout" />
						</NavItem>
					</Nav>
				</div>
			);
		}

		return navBar;
	}
	render() {
		let headerStyle = {
			height: "70%",
			marginBottom: 0,
			borderRadius: 0,
		};
		let headerErrorStyle = {
			backgroundColor: "#f8f8f8",
			height: "30%",
		};
		let headerErrorSpanStyle = {
			color: "rgb(206,63,63)",
		};

		if (this.props.config.css.header && this.props.config.css.header.bgColor) {
			// headerStyle.backgroundImage = "inherit";
			headerStyle.backgroundImage = this.props.config.css.header.bgColor;
		}
		if (this.props.config.css.header && this.props.config.css.header.errorColor) {
			headerErrorSpanStyle.color = this.props.config.css.header.errorColor;
		}

		let headerErrorMessageClassname = "header-error-message";
		if (!this.props.showError) {
			headerErrorMessageClassname += "-hidden";
		}
		const envStyle = {
			fontSize: "medium",
			fontWeight: "bold",
			marginRight: 30,
		};
		let userEnv = "";

		let env = this.props.env;
		if (!env);
		else if (env === "PROD") env = "Production";
		else env = "Test";

		if (this.props.logged) {
			userEnv = this.props.userLogin + " (" + env + ")";
		}

		let logoStyle = {
			padding: 8,
		};

		return (
			<div>
				<Navbar collapseOnSelect style={headerStyle}>
					<Navbar.Header
						className="float-left"
						style={{ marginLeft: 10, marginRight: 3 }}
					>
						<Navbar.Brand>
							<img
								alt="application logo"
								src={this.props.config.logoImageURL}
								style={logoStyle}
							/>
						</Navbar.Brand>
						<Navbar.Toggle />
					</Navbar.Header>
					<Navbar.Collapse>{this.renderNavBar()}</Navbar.Collapse>
				</Navbar>
				<div style={headerErrorStyle}>
					<span
						className={headerErrorMessageClassname + " float-left"}
						style={headerErrorSpanStyle}
					>
						{this.props.errorMessage}
					</span>
					<span className="float-right" style={envStyle}>
						{userEnv}
					</span>
				</div>
			</div>
		);
	}
}

const mapStateToProps = function (store) {
	return {
		logged: store.loginState.logged,
		userSuperAdmin: store.userState.superAdmin,
		uploadEnabled: store.userState.uploadEnabled,
		showError: store.errorState.error,
		errorMessage: store.errorState.message,
		config: store.appState.config,
		env: store.userState.environment,
		userToken: store.userState.token,
		userLogin: store.userState.login,
		uploadFile: store.uploadState.uploadFile,
		uploadProgress: store.uploadState.progress,
		uploadRunning: store.uploadState.running,
	};
};
export default connect(mapStateToProps, null, null, { pure: false })(Header);



// WEBPACK FOOTER //
// ./src/components/layouts/Header.js